module.exports = __webpack_public_path__ + "img/ideation-1_en.57efb6f.jpg";